//Componets
import { RubricTable } from '../../components/rubric/rubric-table';
import { PageHeader } from '../../components/shared';
import Box from '@mui/material/Box';

export const RubricPage = () => {
  return (
    <Box sx={{ mt: { xs: 1.5, sm: '2%' } }}>
      <PageHeader title="Rúbricas" />
      <RubricTable />
    </Box>
  );
};
